module.exports = __webpack_public_path__ + "static/media/share.20347f1e.svg";